import { RootState } from 'js/types';

export function getAllUsageLimits(state: RootState) {
  return state.limits;
}
